export interface Testimonial {
  initials: string
  name: string
  role: string
  text: string
}

export const shortTestimonials: Testimonial[] = [
  {
    initials: '—',
    name: '[Customer Initials]',
    role: 'Taekwondo Instructor — [Location]',
    text: '[Insert verified customer testimonial about saving planning time, class structure or student progression.]',
  },
  {
    initials: '—',
    name: '[Customer Initials]',
    role: 'Taekwondo Coach — [Location]',
    text: '[Insert verified testimonial about the ready-to-teach sessions or technical progressions.]',
  },
  {
    initials: '—',
    name: '[Customer Initials]',
    role: 'Taekwondo Instructor — [Location]',
    text: '[Insert verified testimonial about the drills, coaching system or bonuses.]',
  },
]
